module.exports = __webpack_public_path__ + "img/10.6992b66a.webp";